export default "__VITE_ASSET__0dac4231__"